import { apiFetch } from "./api";

/**
 * Public, non-sensitive policy values pulled from the backend at runtime.
 * Lives in one place so a server-side config change propagates without a
 * frontend redeploy. All money fields are decimal strings.
 */
export interface AppSettings {
	withdraw_min_usd: string;
	withdraw_chain: string;
	referral_min_account_value_usd: string;
	default_revenue_share_bps: number;
	revenue_share_bps?: number;
}

export function fetchAppSettings(address?: string): Promise<AppSettings> {
	const params = address ? `?address=${encodeURIComponent(address)}` : "";
	return apiFetch<AppSettings>(`/v1/app/settings${params}`, { method: "GET" });
}
